import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild } from '@angular/router';
import { BaseParamsService } from '../base-params.service';
import { LanguageSettingsService } from '@app/core/settings/language/language-settings.service';

@Injectable()
export class BaseParamsResolverGuard implements CanActivate, CanActivateChild {
  constructor(
    private baseParamsService: BaseParamsService,
    private languageSettings: LanguageSettingsService,
  ) {}

  public canActivate(route: ActivatedRouteSnapshot): boolean {
    const updated = this.baseParamsService.parseParams(route);
    if (updated) {
      this.languageSettings.setLanguageFromParams();
    }
    return true;
  }

  public canActivateChild(childRoute: ActivatedRouteSnapshot): boolean {
    return this.canActivate(childRoute);
  }
}
